export default __webpack_public_path__ + "static/media/64_photo.a8dc684d.jpg";